<template>
   <div>
    <div class="personal-menu">
      <el-menu v-if="widthNew"
        :default-active="active"
        background-color="#fff"
        active-text-color="#00a8a8"
        :default-openeds="openeds"
        @select="handleSelect"
        
      >
        <el-menu-item index="1" @click="getInfo('')">我的</el-menu-item>
        <el-submenu index="3" v-if="iscompany == true">
          <template slot="title">
            <span>商家服务</span>
          </template>
          <el-menu-item index="3-1" @click="getInfo('商家订单')">订单管理</el-menu-item>
          <el-menu-item index="3-2" @click="getInfo('公司资料')">公司资料</el-menu-item>
          <!-- <el-menu-item index="3-3">产品管理</el-menu-item>
          <el-menu-item index="3-4">视频管理</el-menu-item> -->
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <span>更多服务</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1" @click="getInfo('签到')">签到</el-menu-item>
            <el-menu-item index="2-2" @click="getSession">咨询</el-menu-item>
            <el-menu-item index="2-3" @click="getInfo('购物车')">购物车</el-menu-item>
            <el-menu-item index="2-4" @click="getTeams">我的团队</el-menu-item>
            <el-menu-item index="2-12" @click="getDistribution">分销人员</el-menu-item>
            <el-menu-item index="2-5" @click="getMyExpertChatOrders">专家订单</el-menu-item>
            <el-menu-item index="2-6" @click="getBooking">我的报名</el-menu-item>
            <el-menu-item index="2-7" @click="getBindBankCard">绑银行卡</el-menu-item>
            <el-menu-item index="2-8" @click="getmyApplyToCash">我的提现</el-menu-item>
            <!-- <el-menu-item index="2-9">我要分享</el-menu-item> -->
            <el-menu-item index="2-10" @click="myFav">我的收藏</el-menu-item>
            <el-menu-item index="2-11" @click="getUconfig">设置</el-menu-item>
            <el-menu-item index="2-12" @click="getUserDelete">退出</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
       
        <!-- <el-submenu index="3">
          <template slot="title">
            <span>帮助中心</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="3-1">交易流程</el-menu-item>
            <el-menu-item index="3-2">如何支付</el-menu-item>
            <el-menu-item index="3-3">查订单进度</el-menu-item>
            <el-menu-item index="3-4">如何询价</el-menu-item>
            <el-menu-item index="3-5">售后服务</el-menu-item>
            <el-menu-item index="3-6">加入我们</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
      </el-menu>


     
    </div>
   </div>
  
</template>
<script>
export default {
  data(){
    return{
      openeds: ['2','3'],
      active: '1',
      widthNew: false,
      issalesman: false,
      isexpert: false,
      iscompany: false
    }
  },
  methods: {
    getInfo(value){
      if(value == ''){
        this.$router.push({
          path: '/personal',
        })
      }else if(value == '签到'){
        this.$router.push({
          path: '/mySign',
        })
      }else if(value == '购物车'){
        this.$router.push({
          path: '/cart',
        })
      }else if(value == '商家订单'){
        this.$router.push({
          path: '/merchant'
        })
      }else if(value == '公司资料'){
        this.$router.push({
          path: '/companyInformation'
        })
      }
    },
    getTeams(){
      this.$router.push({
        path: '/teams'
      })
    },
    getSession(){
      this.$router.push({
        path: '/session'
      })
    },
    getDistribution(){
      this.$router.push({
        path: '/distribution'
      })
    },
    getBooking(){
      this.$router.push({
        path: '/MyBooking'
      })
    },
    getUconfig(){
      this.$router.push({
        path: '/uconfig'
      })
    },
    handleSelect(key, keyPath) {
      console.log('select');
      console.log(key, keyPath);
      this.active = key
      localStorage.setItem('active',key)
    },
    myFav(){
      this.$router.push({
        path: '/myFav'
      })
    },
    getMyExpertChatOrders(){
      this.$router.push({
        path: '/MyExpertChatOrders'
      })
    },
    getmyApplyToCash(){
      this.$router.push({
        path: '/myApplyToCash'
      })
    },
    getBindBankCard(){
      this.$router.push({
        path: '/bindBankCard'
      })
    },
    getUserDelete(){
      this.$confirm('确定要退出登陆吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        window.onbeforeunload = function (e) {
            var storage = window.localStorage;
            storage.clear()
        }
        this.$forceUpdate()
        this.$router.push('/homePage')
      }).catch(() => {
              
      });
    },
    UniUserRole(ucode){
      var UserRoles = sessionStorage.getItem('qiliangongRoles')
      
      if(UserRoles != null && UserRoles != undefined && UserRoles != ''){
          var MyUserMenus = JSON.parse(UserRoles)
          var dpn = UserRoles.length
          console.log(dpn)
          var pn=0
          if(dpn>0){
              for(var i=0;i<dpn;i++){
                  var item = MyUserMenus[i]
                
                  var codev = item
                  if(ucode == codev){
                      pn=pn+1
                  }
              }
          }

          if(pn>0){
              return true
          }else{
              return false
          }
      
      }else{
          return false
      }
    },
  },
  created(){
    let widthNew = document.documentElement.clientWidth
    if(widthNew > 540){
        this.widthNew = true
    }else{
        this.widthNew = false
    }
    if(localStorage.getItem('active')){
      this.active = localStorage.getItem('active')
    }
    this.iscompany = this.UniUserRole('company') // 商家
    this.issalesman = this.UniUserRole('salesman') // 销售
    this.isexpert = this.UniUserRole('isexpert') // 专家
  }
}
</script>
<style scoped>


.personal-menu{
    width: 200px;
    background: #fff;
    padding: 15px 15px;
    align-self: flex-start;
    text-align: center;
}
.personal-menu .el-menu{border:0;}
.personal-menu .el-submenu:hover{
  background-color: #fff !important;
}
.personal-menu .el-submenu span{
  font-size: 18px;
}
.personal-menu .el-menu-item {
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.personal-menu.el-menu-item.is-active {
  background-color: #fff !important;
  border-bottom: 1px solid rgba(0, 168, 168, 0.1) !important;
  margin-top:1px;
}
.personal-menu .el-menu-item:hover{
    background-color: #fff !important;
    color: rgba(0, 168, 168);
    margin-top:1px;
}

.personal-menu .el-menu .el-submenu .el-menu-item{
  font-size: 16px;
}

.personal-context{
    width: 900px;
    margin-left: 20px;
    background: #fff;
    padding: 15px 15px;
   
}

@media screen and (max-width: 540px) {
  .personal-menu{
    width: 100%;
    margin: 20px auto;
    padding: 10px 0px;
  }
  ::v-deep .personal-menu .el-menu--horizontal>.el-submenu .el-submenu__title{
    font-size: 17px !important;
    color: #333333 !important;
    margin-top: 1px !important;
  }
}
</style>